export default __webpack_public_path__ + "static/media/4_5.51051250.png";